import { createFileRoute } from "@tanstack/react-router";
import CardListing from "@/pages/CardListing";
import { SITE_ORIGIN } from "@/lib/routeSeo";

const title = "Alle Kreditkarten in Deutschland – Zinsen & Gebühren vergleichen";
const description =
  "Vergleichen Sie alle Kreditkarten in Deutschland. Finden Sie die beste Karte mit niedrigen Zinsen, ohne Jahresgebühr oder mit Bonusprogramm.";
const url = `${SITE_ORIGIN}/kreditkarten`;

export const Route = createFileRoute("/kreditkarten/")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
    ],
    links: [{ rel: "canonical", href: url }],
  }),
  component: CardListing,
});
